<template>
    <div id="app">
        <header-bar v-if="!$route.meta.noNeedHeader" />
        <router-view />
        <footer-bar />
    </div>
</template>
<script>
import headerBar from '@/components/headerBar/index.vue';
import footerBar from '@/components/footerBar/index.vue';
export default {
    components: {
        headerBar,
        footerBar
    }
};
</script>
<style lang="scss">
#app {
}
</style>
